"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Icon } from "@iconify/react";
import { Drawer, NavLink } from "@mantine/core";
import Link from "next/link";
import { getShopConfig } from "@/server/shop/get-shop-config";
export default function MobileMenu(t0) {
  const $ = _c(41);
  const {
    mitems: t1,
    acats: t2,
    contentColor
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const mitems = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const acats = t4;
  const [showMenu, setShowMenu] = useState(false);
  let menuBgClass;
  let menuBgColor;
  let menuTextClass;
  let menuTextColor;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    const nshop = getShopConfig();
    if (nshop.id === "aspireeciguk") {
      menuBgColor = "var(--color-secondary)";
      menuBgClass = "bg-secondary";
      menuTextColor = "var(--color-white)";
      menuTextClass = "text-white";
    } else {
      if (nshop.id === "bulkvapewholesale") {
        menuBgColor = "var(--color-primary)";
        menuBgClass = "bg-secondary";
        menuTextColor = "var(--color-white)";
        menuTextClass = "text-white";
      } else {
        menuBgColor = "var(--color-primary)";
        menuBgClass = "bg-primary";
        menuTextColor = "var(--color-white)";
        menuTextClass = "text-white";
      }
    }
    $[4] = menuBgClass;
    $[5] = menuBgColor;
    $[6] = menuTextClass;
    $[7] = menuTextColor;
  } else {
    menuBgClass = $[4];
    menuBgColor = $[5];
    menuTextClass = $[6];
    menuTextColor = $[7];
  }
  let t5;
  if ($[8] !== contentColor || $[9] !== mitems.length || $[10] !== showMenu) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const ditems = [{
        type: "pages",
        url: "/",
        label: "Home"
      }, {
        type: "collections",
        url: "/collections",
        label: "Collections"
      }, {
        type: "brands",
        url: "/brands",
        label: "Brands"
      }, {
        type: "products",
        url: "/products",
        label: "Products"
      }, {
        type: "blogs",
        url: "/blogs",
        label: "Blogs"
      }];
      if (!mitems.length) {
        const t6 = `flex lg:hidden ${contentColor}`;
        let t7;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = () => setShowMenu(true);
          $[12] = t7;
        } else {
          t7 = $[12];
        }
        let t8;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>;
          $[13] = t8;
        } else {
          t8 = $[13];
        }
        let t9;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="transparent" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== t6) {
          t10 = <span className={t6} onClick={t7} role="button" aria-label="menu">{t8}{t9}</span>;
          $[15] = t6;
          $[16] = t10;
        } else {
          t10 = $[16];
        }
        let t11;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t11 = () => setShowMenu(false);
          $[17] = t11;
        } else {
          t11 = $[17];
        }
        const t12 = <div className="flex flex-col gap-1">{ditems.map((ditem, dtx) => {
            const key = ditem.id;
            let href;
            if (ditem.type === "pages" && ditem.url === "/") {
              href = "/";
            } else {
              if (ditem.type === ditem.url.replace("/", "")) {
                href = `/${ditem.type}`;
              } else {
                href = `/${ditem.type}/${ditem.url.replace(/^\//, "")}`;
              }
            }
            return <Link key={key} href={href} label={ditem.label} onClick={() => setShowMenu(false)} className={`rounded-lg ${menuBgClass} ${menuTextClass} px-3 py-2 font-heading`}>{ditem.label}</Link>;
          })}</div>;
        let t13;
        if ($[18] !== showMenu || $[19] !== t12) {
          t13 = <Drawer opened={showMenu} onClose={t11} size="sm" title="Menu">{t12}</Drawer>;
          $[18] = showMenu;
          $[19] = t12;
          $[20] = t13;
        } else {
          t13 = $[20];
        }
        let t14;
        if ($[21] !== t10 || $[22] !== t13) {
          t14 = <>{t10}{t13}</>;
          $[21] = t10;
          $[22] = t13;
          $[23] = t14;
        } else {
          t14 = $[23];
        }
        t5 = t14;
        break bb0;
      }
    }
    $[8] = contentColor;
    $[9] = mitems.length;
    $[10] = showMenu;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  const t6 = `flex lg:hidden ${contentColor}`;
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShowMenu(true);
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="transparent" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t6) {
    t10 = <span className={t6} onClick={t7} role="button" aria-label="menu">{t8}{t9}</span>;
    $[27] = t6;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setShowMenu(false);
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== acats || $[31] !== mitems) {
    t12 = mitems?.length > 0 && mitems?.map((item, index) => {
      let href_0;
      if (item.type === "pages" && item.url === "/") {
        href_0 = "/";
      } else {
        if (item.type === item.url.replace("/", "")) {
          href_0 = `/${item.type}`;
        } else {
          href_0 = `/${item.type}/${item.url.replace("/", "")}`;
        }
      }
      return item?.children?.length > 0 ? <NavLink key={index} label={item.label} variant="filled" ff="heading" bg={menuBgColor} c={menuTextColor} className="rounded-lg" childrenOffset={0}>{item?.children?.map((child, cdx) => {
          let chref;
          if (child.type === "pages" && child.url === "/") {
            chref = "/";
          } else {
            if (child.type === child.url.replace("/", "")) {
              chref = `/${child.type}`;
            } else {
              chref = `/${child.type}/${child.url.replace("/", "")}`;
            }
          }
          const matchedCat = acats?.find(acat => acat.cat_slug === child.url);
          matchedCat?.cat_image || null;
          return child?.children?.length > 0 ? <NavLink key={child.id} label={child.label} bg={menuBgColor} c={menuTextColor} ff="heading" leftSection={<Icon icon="mdi:chevron-right" />} mb={4} className="rounded-lg" childrenOffset={0}>{child?.children?.map((dchild, ddx) => {
              let dhref;
              if (dchild.type === "pages" && dchild.url === "/") {
                dhref = "/";
              } else {
                if (dchild.type === dchild.url.replace("/", "")) {
                  dhref = `/${dchild.type}`;
                } else {
                  dhref = `/${dchild.type}/${dchild.url.replace("/", "")}`;
                }
              }
              return <Link key={ddx} href={dhref} className="flex flex-col mb-1 font-heading" onClick={() => setShowMenu(false)}><span className="flex items-center py-2 px-3 gap-4 rounded-lg bg-secondary text-white font-medium text-center text-balance"><Icon icon="mdi:chevron-double-right" /> {dchild.label}</span></Link>;
            })}</NavLink> : <Link href={chref} className="flex flex-col mb-1 font-heading" onClick={() => setShowMenu(false)}><span className="flex items-center py-2 px-3 rounded-lg bg-secondary text-white font-medium text-center text-balance">{child.label}</span></Link>;
        })}</NavLink> : <Link key={index} href={href_0} label={item.label} onClick={() => setShowMenu(false)} className={`rounded-lg ${menuBgClass} ${menuTextClass} px-3 py-2 font-heading`}>{item.label}</Link>;
    });
    $[30] = acats;
    $[31] = mitems;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12) {
    t13 = <div className="pt-4 flex flex-col gap-1">{t12}</div>;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== showMenu || $[36] !== t13) {
    t14 = <Drawer opened={showMenu} onClose={t11} size="sm" title="Menu">{t13}</Drawer>;
    $[35] = showMenu;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t10 || $[39] !== t14) {
    t15 = <>{t10}{t14}</>;
    $[38] = t10;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}